import { useState } from 'react';
import { TooltipKey } from '../../mockdata/tooltips';
import ErrorBlock from './ErrorBlock';
import FormField from './FormField';
import { useFormContext, useWatch } from 'react-hook-form';

type MultilineProps = {
  multiline: true;
  rows?: number;
  type?: never; // ❌ forbidden
};
type SinglelineProps = {
  multiline?: false; // default
  type?: 'text' | 'email' | 'password' | 'number';
  rows?: never; // ❌ rows not allowed
};

interface BaseProps {
  name: string;
  label: string;
  maxLength?: number;
  required?: boolean;
  requiredMessage?: string;
  tooltipKey?: TooltipKey;
  placeholder?: string;
}

type Props = BaseProps & (MultilineProps | SinglelineProps);

export function TextInputField({ name, label, maxLength, required, requiredMessage, tooltipKey, placeholder, multiline, rows, type }: Props) {
  const ctx = useFormContext();

  if (!ctx || !ctx.register) {
    throw new Error(
      `<TextInputField> must be used inside a <FormProvider>. 
     You probably forgot to wrap your <form> in <FormProvider {...methods}>`
    );
  }

  const {
    register,
    control,
    formState: { errors },
  } = ctx;
  const currentValue = useWatch({ control, name }) || '';

  const [len, setLen] = useState(currentValue.length);
  const fieldError = errors[name];

  const rules: any = {
    maxLength,
    onChange: (e: any) => setLen(e.target.value.length),
  };

  if (required) {
    rules.required = requiredMessage || `${label} is required`;
  }

  return (
    <FormField name={name} label={label} required={required} error={fieldError} tooltipKey={tooltipKey} noErrorBlock>
      <>
        {multiline ? (
          <textarea placeholder={placeholder} maxLength={maxLength} rows={rows} {...register(name, rules)} />
        ) : (
          <input type={type || 'text'} placeholder={placeholder} maxLength={maxLength} {...register(name, rules)} />
        )}
            {/* {maxLength && (
              <div className="d-flex justify-content-end text-muted mt-1">
                {len}/{maxLength}
              </div>
            )} */}

        <ErrorBlock error={fieldError} maxLength={maxLength} currentLength={len} />
      </>
    </FormField>
  );
}
